
export const VsType = {
  five: 0,
  three: 3,
  solo: 1,
  two: 2,
  ten: 10,
};
export const BpType = {
  four: 0,
  three: 4,
  two: 3,
  zero: 1,
};

export const TeamMemRange = {
  [VsType.solo]: { min: 1, max: 5, defaultNum: 1 },
  [VsType.three]: { min: 3, max: 7, defaultNum: 5 },
  [VsType.five]: { min: 5, max: 10, defaultNum: 7 },
  [VsType.two]: { min: 2, max: 7, defaultNum: 2 },
  [VsType.ten]: { min: 10, max: 15, defaultNum: 12 },
};

export const DefaultTeamMem = 5;
